import { propertyDisabledReasons } from 'common/constants/landlord';

export const formatSelectedProperties = properties => {
  return (
    properties.map(item => ({
      ...item,
      disabled: item.status?.toLowerCase() === propertyDisabledReasons.PUBLISHED,
    })) || []
  );
};

export const shouldDisableCurrency = properties => {
  return properties.some(item => item.status?.toLowerCase() === propertyDisabledReasons.PUBLISHED);
};

export const getDisabledReason = (reason, t) => {
  switch (reason) {
    case propertyDisabledReasons.PUBLISHED:
      return t('landlord:landlord.payment.long_tail.initial_setup.property.disabled.published');
    case propertyDisabledReasons.LINKED:
      return t('landlord:landlord.payment.long_tail.initial_setup.property.disabled.linked');
    case propertyDisabledReasons.NOT_KEY:
      return t('landlord:landlord.payment.long_tail.initial_setup.property.disabled.notKey');
    default:
      return t(
        'landlord:landlord.payment.long_tail.initial_setup.property.disabled.linked_and_published',
      );
  }
};
